import React from 'react'

import { Flex, Text } from '@chakra-ui/layout'

import { CellValue, Row } from 'react-table'

import { ModalShowAccredited } from './Modal/ShowAccredited'
import { ModalRemoveAccredited } from './Modal/RemoveAccredited'
import { ModalEditAccredited } from './Modal/EditAccredited'

export function CellText({ value }: CellValue) {
  return <Text fontSize="sm">{value}</Text>
}

export function CellPhone({ value }: CellValue) {
  return (
    <Text fontSize="sm">
      {value
        .replaceAll(' ', '')
        .replace(/(\d{2})(\d{4,5})(\d{4})/g, '($1) $2-$3')}
    </Text>
  )
}

export function CellActions({ original }: Pick<Row, 'original'>) {
  return (
    <Flex>
      <ModalShowAccredited original={original} />
      <ModalEditAccredited original={original} />
      <ModalRemoveAccredited original={original} />
    </Flex>
  )
}
